import { render, staticRenderFns } from "./ProductFilter.vue?vue&type=template&id=0ca88e1e&"
import script from "./ProductFilter.js?vue&type=script&lang=js&"
export * from "./ProductFilter.js?vue&type=script&lang=js&"
import style0 from "./ProductFilter.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports